import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import _remove from 'lodash/remove';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import FormikPropsValidations from './FormikPropsValidations';
import FieldValidationPopup from '../Poppers/FieldValidation';
import ChipFieldStyles from './__styles__/ChipField.styles';

export class ChipField extends Component {
  static propTypes = {
    name: props => FormikPropsValidations('name', props),
    label: PropTypes.string,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  };

  state = {
    value: this.props.value || [],
    anchorEl: null,
    fieldError: '',
    fieldName: this.props.name || _get(this.props, 'field.name')
  };

  componentDidMount() {
    this._setFieldError();
  }

  componentDidUpdate(prevProps) {
    const { validateField } = this.props;
    const { fieldName } = this.state;
    if (_get(prevProps, 'form.errors') !== _get(this.props, 'form.errors')) {
      this._setFieldError();
    }

    if (prevProps.value !== this.props.value) {
      if (_isFunction(validateField)) {
        validateField(fieldName, this.props.value);
      }
      this.setState({ value: this.props.value || '' });
    }
  }

  _setFieldError = () => {
    const { fieldName } = this.state;
    const { form = {} } = this.props;
    const { errors } = form;
    const error = _get(errors, fieldName, '');
    this.setState({ fieldError: error });
  };

  _handleShowError = event => {
    const { fieldError } = this.state;
    if (fieldError) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  _handleHideError = () => {
    this.setState({ anchorEl: null });
  };

  _handleAdd = chip => {
    const { onChange, value } = this.props;
    let allValues = [];
    if (chip.includes(',')) {
      const chips = chip.split(',');
      allValues = value.concat(chips);
    } else if (chip.includes(';')) {
      const chips = chip.split(';');
      allValues = value.concat(chips);
    } else {
      allValues = value || [];
      allValues.push(chip);
    }
    const trimmedValues = allValues.map(chippedInput => {
      return chippedInput.trim();
    }); // this was needed in case they did test; test
    onChange({ target: { name: this.state.fieldName, value: trimmedValues } });
  };

  _handleDelete = chip => {
    const { onChange, value } = this.props;
    const values = [...value];
    _remove(values, value => value === chip);
    onChange({ target: { name: this.state.fieldName, value: values } });
  };

  render() {
    const { classes, label, value = [] } = this.props;

    return (
      <Fragment>
        <ChipInput
          fullWidth
          fullWidthInput
          onAdd={this._handleAdd}
          onDelete={this._handleDelete}
          label={label}
          value={value}
          blurBehavior={'add'}
          variant={'outlined'}
          onMouseEnter={this._handleShowError}
          onFocus={this._handleShowError}
          onMouseOut={this._handleHideError}
          error={!!this.state.fieldError}
          chipRenderer={({ text, handleDelete }, key) => {
            return (
              <Chip
                key={key}
                label={text}
                className={classes.chip}
                classes={{ label: classes.chipLabel }}
                onDelete={handleDelete}
                deleteIcon={<CloseIcon className={classes.chipIcon} />}
              />
            );
          }}
          classes={{
            inputRoot: classes.chipInputRoot,
            input: classes.chipInput,
            label: classes.chipInputLabel
          }}
        />
        <FieldValidationPopup
          anchorEl={this.state.anchorEl}
          message={this.state.fieldError}
        />
      </Fragment>
    );
  }
}

export default withStyles(ChipFieldStyles)(ChipField);
